"use strict";
export const getUniquePositionId = (poolId, tokenId, chainId) => {
  return `${poolId}-${tokenId}-${chainId}`;
};
